import { useServiceAccess, useServiceTypePlace } from '@church/data'
import { faPlus } from '@church/ui-icons'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { PageAction } from '../components/PageAction.tsx'
import { NewTemplatePanel, TemplateList } from '../components/services/Templates.tsx'
import { Card, EmptyState, PageHeader, Spinner } from '../components/ui.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'
import { folderCrumbs } from '../lib/services-crumbs.ts'

/**
 * A service type's plan templates (docs/14-TEAMS-PEOPLE-TEMPLATES.md): its
 * usual plans, the default marked. Its Editors read them (New plan uses
 * them); its Administrators make and change them, here or in the
 * service type's settings (G3b), which has them as a section.
 */
export const Route = createFileRoute('/_authed/_shell/services/types/$typeId/templates/')({
  component: TemplatesScreen,
})

function TemplatesScreen() {
  const { typeId } = Route.useParams()
  const access = useServiceAccess()
  const place = useServiceTypePlace(typeId)
  const [adding, setAdding] = useState(false)
  const admin = access.can(typeId, 'administrator')
  // Plans › Main campus › Sunday Morning › Templates; its Administrators
  // manage them in its settings (G3b): … › Sunday Morning › Settings › Templates.
  useBreadcrumbs([
    ...folderCrumbs(place.folders),
    ...(place.type ? [{ label: place.type.name, href: `/services/types/${typeId}` }] : []),
    ...(admin
      ? [{ label: 'Settings', href: `/services/types/${typeId}/settings?tab=Templates` }]
      : []),
    { label: 'Templates' },
  ])
  if (!access.ready) return <Spinner />
  if (!place.type || !access.can(typeId, 'editor'))
    return (
      <Card>
        <EmptyState
          title="No templates to show"
          hint="A service’s templates are for its Editors and Administrators."
        />
      </Card>
    )
  return (
    <div className="space-y-4">
      <PageHeader
        title={`${place.type.name} templates`}
        action={
          admin ? (
            <PageAction icon={faPlus} label="New template" onClick={() => setAdding(true)}>
              New template
            </PageAction>
          ) : undefined
        }
      />
      <TemplateList typeId={typeId} />
      {admin && <NewTemplatePanel typeId={typeId} open={adding} onClose={() => setAdding(false)} />}
    </div>
  )
}
